import React, { useEffect, useState } from 'react';
import type { Vehicle } from '@/services/vehicles/vehiclesService';

export interface FleetVehicleReferenceInputProps {
  vehicle: Vehicle;
  onSave: (vehicle: Vehicle, rawValue: string) => Promise<void>;
}

/**
 * Redigerbar referens i fordonslistan — sparas vid blur / Enter.
 */
const FleetVehicleReferenceInput: React.FC<FleetVehicleReferenceInputProps> = ({ vehicle, onSave }) => {
  const saved = vehicle.reference_number ?? '';
  const [local, setLocal] = useState(saved);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLocal(vehicle.reference_number ?? '');
  }, [vehicle.id, vehicle.reference_number]);

  const commit = async () => {
    if (saving) return;
    const trimmed = local.trim();
    const prev = (vehicle.reference_number ?? '').trim();
    if (trimmed === prev) return;
    setSaving(true);
    try {
      await onSave(vehicle, local);
    } catch {
      setLocal(vehicle.reference_number ?? '');
    } finally {
      setSaving(false);
    }
  };

  return (
    <input
      type="text"
      value={local}
      disabled={saving}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={() => void commit()}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          (e.target as HTMLInputElement).blur();
        }
      }}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      maxLength={100}
      className="block w-full max-w-[8.5rem] box-border px-2 py-1 text-sm text-left border border-border rounded-md bg-bgBase text-textDefault placeholder:text-textSecondary focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-60"
      aria-label="Referens"
    />
  );
};

export default FleetVehicleReferenceInput;
